import LayoutOnboardingTitleComponent from "components/layout-onboarding-title/LayoutOnboardingTitleComponent";
import "./LayoutOnboardingComponent.css";

const LayoutOnboardingComponent = ({
  children,
  subtitle,
  title,
  bottomAction,
}) => {
  return (
    <div className='layout-onboarding'>
      <div className='layout-onboarding-form-section'>
        <div className='layout-onboarding-form-brand'>
          <img
            alt='qaptive-logo'
            className='layout-onboarding-form-qaptive-logo'
            src='/images/logo/qaptive-logo.svg'
            width={404}
            height={99}
          />
        </div>
        <div className='layout-onboarding-form-container'>
          <div className='layout-onboarding-form'>
            <div>
              <LayoutOnboardingTitleComponent title={title} />
              <p className='layout-onboarding-form-desc'>{subtitle}</p>
            </div>

            {children}
          </div>
        </div>
        {Boolean(bottomAction) && (
          <div className='layout-onboarding-form-bottom-action'>
            {bottomAction}
          </div>
        )}
      </div>
      <div className='layout-onboarding-brand'>
        <img
          alt='aml-cover'
          src='/images/login-cover.svg'
          className='layout-onboarding-cover-image'
        />
      </div>
    </div>
  );
};

export default LayoutOnboardingComponent;
